import { InjectionToken } from '@angular/core';
import { ScreenshotReportsPort } from './screenshot-reports.port';

export const SCREENSHOT_REPORTS_PORT = new InjectionToken<ScreenshotReportsPort>('SCREENSHOT_REPORTS_PORT');

